export default __webpack_public_path__ + "static/lim-eb7fbfe394d03d761bb31a4fbce2ca5c.jpg";